<template>
  <div class="constituency-container" v-if="currentConstituency && currentConstituency.name">
    <h2>Your constituency</h2>
    <p v-markdown="currentData.desc"></p>
    <div class="img-container">
      <img class="img-map" :src="`assets/images/${currentData['mini-map']}`" />
    </div>
    <p v-if="currentData['contesting-long']" v-markdown="currentData['contesting-long']"></p>
    <candidates />
    <p v-if="currentData.manifesto" v-markdown="currentData.manifesto"></p>
    <p v-if="currentData.social" v-markdown="currentData.social"></p>
    <p>View all the candidates contesting in GE2020 <a target="_blank" :href="candidatesLink">here.</a></p>
    <p v-if="currentData.historical" v-markdown="currentData.historical"></p>
    <p>Get the latest stories about your constituency, {{currentConstituency.name}}, <a target="_blank" :href="currentData['tag-page'] || defaultLink">here</a> and follow our coverage of GE2020 <a target="_blank" :href="defaultLink">here</a>.</p>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import _find from 'lodash/find'
import {store} from '../store-constituency'
import Candidates from './candidates'

export default {
  props: ['attributes'],
  components: {
    Candidates
  },
  computed: {
    ...mapState(['eventsconstituencies']),
    currentConstituency () {
      return store.currentConstituency
    }
  },
  data () {
    return {
      currentData: {},
      defaultLink: 'https://www.straitstimes.com/politics',
      candidatesLink: 'https://www.straitstimes.com/multimedia/graphics/2020/06/singapore-general-election-ge2020-candidates/index.html'
    }
  },
  watch: {
    'currentConstituency.name': function (newVal, oldVal) {
      this.getConstituency()
    }
  },
  methods: {
    getConstituency: function () {
      if (!this.currentConstituency || !this.currentConstituency.name) return

      const found = _find(this.eventsconstituencies, {constituency: this.currentConstituency.name})
      this.currentData = found || this.currentData
    }
  }
}
</script>

<style lang="scss">
.constituency-container {
  padding: 30px 0;
  p {
    padding: 17px 0;
  }

  .img-container {
    text-align: center;
    img.img-map {
      max-width: 400px;
      width: 100%;
    }
  }
}
</style>
